export default "__VITE_ASSET__DxpsT8yY__"